import type { Currency, Money } from '../schemas/primitives.js';

/** Convert sen (or other minor units) to display string. */
export function format(amount: Money, currency: Currency = 'MYR', locale = 'en-MY'): string {
  const major = amount / 100;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(major);
}

/** Sum of money values; bounded by Number.MAX_SAFE_INTEGER. */
export function sum(values: readonly Money[]): Money {
  return values.reduce((acc, v) => acc + v, 0);
}

/** Multiply by a multiplier (e.g., percent). Returns rounded sen. */
export function multiply(amount: Money, factor: number): Money {
  return Math.round(amount * factor);
}

/** Percent off helper — value is 0..100. */
export function percentOff(amount: Money, value: number): Money {
  if (value < 0 || value > 100) throw new RangeError('percent must be in [0,100]');
  return Math.round(amount * (value / 100));
}
